import { useTheme } from 'native-base';

import { Thermometer02Icon } from '../icons/thermometer-02';
import { DoorEventIcon } from '../icons/door-event';
import { RouterIcon } from '../icons/router';

type HardwareTypeIconProps = {
  type: 'temp' | 'door' | 'gateway';
  size?: string;
};

export const HardwareTypeIcon = ({ type, size = 'md' }: HardwareTypeIconProps) => {
  const { colors } = useTheme();
  const color = colors.gray[400];

  if (type === 'door') return <DoorEventIcon size={size} color={color} />;
  if (type === 'gateway') return <RouterIcon size={size} color={color} />;
  return <Thermometer02Icon size={size} color={color} />;
};
